export default __webpack_public_path__ + "static/8-d1487551c27cf99cca6c0dfb868c37c8.jpg";